import { authHeader, golangHeader } from "@helper/authHeader";
import { baseUrl } from "@helper/ApiCall";
import { basePathApiGolang } from "@helper/basePathApi";
import { apiClient } from "./apiClient";

const version = process.env.REACT_APP_VERSION;
const inFlightGetRequests = new Map();
const inFlightPostRequests = new Map();

export const SC = {
  getCall,
  postCall,
  putCall,
  deleteCall,
  postCallWithOrg,
  postCallLoginAdmin,
  postCallWithoutAuth,
  getCallWithOrgId,
  getCallWithParams,
  putCallWithOrg,
  postAttachment,
  getCallWithId,
  getCallWithoutAuth,
  deleteCallWithPost,
  postCallWithOutRole,
  getCallWithTeam,
  postCallWithRole,
  postCall_golang,
  getCall_golang,
  getCallWithIdwithOrgId,
  getFileUrl,
};

function buildOrgRoleParams(queryParams) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  return {
    version,
    role,
    organization_id: id,
    ...(queryParams || {}),
  };
}

function stableStringify(value) {
  if (!value || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(",")}]`;
  }
  const sortedKeys = Object.keys(value).sort();
  return `{${sortedKeys
    .map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`)
    .join(",")}}`;
}

function withDedupedGetRequest(requestKey, requestFn) {
  if (inFlightGetRequests.has(requestKey)) {
    return inFlightGetRequests.get(requestKey);
  }

  const requestPromise = requestFn().finally(() => {
    inFlightGetRequests.delete(requestKey);
  });

  inFlightGetRequests.set(requestKey, requestPromise);
  return requestPromise;
}

function withDedupedPostRequest(requestKey, requestFn) {
  if (inFlightPostRequests.has(requestKey)) {
    return inFlightPostRequests.get(requestKey);
  }

  const requestPromise = requestFn().finally(() => {
    inFlightPostRequests.delete(requestKey);
  });

  inFlightPostRequests.set(requestKey, requestPromise);
  return requestPromise;
}

function shouldDedupGolangPost(url) {
  return url === "tickets" || url.startsWith("tickets/chartData/");
}

function getCall(url, queryParams) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
    params: buildOrgRoleParams(queryParams),
    paramsSerializer: (params) => {

      const searchParams = new URLSearchParams();

      Object.keys(params).forEach((key) => {

        const value = params[key];

        if (Array.isArray(value)) {

          if (value.length === 1) {

            // force array style even for single values

            searchParams.append(`${key}[]`, value[0]);

          } else {

            value.forEach((v) => searchParams.append(`${key}[]`, v));

          }

        } else if (value !== undefined && value !== null) {

          searchParams.append(key, value);

        }

      });

      return searchParams.toString();

    },
  };

  const fullUrl = baseUrl + url;
  const requestKey = `GET:${fullUrl}:params=${stableStringify(
    requestOptions.params
  )}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function postCallWithRole(url, Id) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  return apiClient.post(
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`,
    Id,
    requestOptions
  );
}

function getCallWithOrgId(url) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const fullUrl =
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`;
  const requestKey = `GET:${fullUrl}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function getCallWithParams(url, params = {}) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const merged = {
    ...params,
    version,
    organization_id: localStorage.getItem("orgId"),
  };

  const qs = Object.entries(merged)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  const fullUrl = baseUrl + url + "?" + qs;
  const requestKey = `GET:${fullUrl}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

  function postCall(url, data, callbackProgressUpload = null, source, orgId = null) {
  const id = orgId ?? localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = orgId
    ? `version=${version}&organization_id=${id}`
    : `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  return apiClient.post(
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`,
    data,
    !url.includes("get-all-team") && requestOptions
  );
}

function postCallWithOrg(url, data, callbackProgressUpload = null, source) {
  const role = localStorage.getItem("currentRole");

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  return apiClient.post(baseUrl + url + `&version=${version}&role=${role}`, data, requestOptions);
}

function postAttachment(url, data, callbackProgressUpload = null, source) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  return apiClient.post(url, data, requestOptions);
}

function putCallWithOrg(url, data) {
  const role = localStorage.getItem("currentRole");
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return apiClient.put(baseUrl + url + `&version=${version}&role=${role}`, data, requestOptions);
}

function putCall(url, data) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
  };

  return apiClient.put(
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`,
    data,
    requestOptions
  );
}

function deleteCall(url) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return apiClient.delete(
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`,
    requestOptions
  );
}

function deleteCallWithPost(url, ids, callbackProgressUpload = null, source) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");
  const queryParam = `version=${version}&role=${role}&organization_id=${id}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  return apiClient.post(
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`,
    ids,
    requestOptions
  );
}

function postCallLoginAdmin(url, data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  return apiClient
    .post(baseUrl + url + `?version=${version}`, data, requestOptions)
    .then((response) => {
      if (response?.data) {
        const payload = response.data;
        // localStorage.setItem("userToken", JSON.stringify(payload));
        localStorage.setItem(
          "firstTimeLogin",
          JSON.stringify(response?.data?.isPasswordUpdated)
        );
        localStorage.setItem("userEmail", JSON.stringify(response?.data?.email));
      }
      return response;
    });
}

function getCallWithoutAuth(url) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  const fullUrl =
    baseUrl + url + `${url.includes("?") ? "&version=" : "?version="}` + version;
  const requestKey = `GET:${fullUrl}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function postCallWithoutAuth(url, data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  return apiClient.post(baseUrl + url + `?version=${version}`, data, requestOptions);
}

function getCallWithId(url, id) {
  const role = localStorage.getItem("currentRole");

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const fullUrl =
    baseUrl + url + "/" + id + `?version=${version}&role=${role}&organization_id=${id}`;
  const requestKey = `GET:${fullUrl}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function getCallWithTeam(url, params = {}) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");

  const mergedParams = {
    ...params,
    version,
    role,
    organization_id: id,
  };

  const queryParam = Object.entries(mergedParams)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const fullUrl =
    baseUrl + url + `${url.includes("?") ? "&" + queryParam : "?" + queryParam}`;
  const requestKey = `GET:${fullUrl}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function postCallWithOutRole(url, data, callbackProgressUpload = null, source) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  return apiClient.post(
    baseUrl + url + `${url.includes("?") ? "&version=" : "?version="}` + version,
    data,
    requestOptions
  );
}

//  GOLANG API SERVER CALLS
function postCall_golang(url, data, page, per_page, callbackProgressUpload = null, source, sorting) {
  const id = localStorage.getItem("orgId");
  const requestOptions = {
    headers: golangHeader(),
    onUploadProgress: (progressEvent) => {
      if (callbackProgressUpload) callbackProgressUpload(progressEvent);
    },
  };

  if (source) requestOptions.cancelToken = source.token;

  let endPoint = url;
  const queryParameters = new URLSearchParams(endPoint.split("?")[1]);
  if (!queryParameters.has("organization_id")) {
    if (page) {
      endPoint =
        endPoint +
        "/" +
        id +
        "?organization_id=" +
        id +
        "&page=" +
        page +
        "&perPage=" +
        per_page;
    } else {
      endPoint = endPoint + "?organization_id=" + id;
    }
  } else {
    if (page) {
      endPoint = endPoint + "&page=" + page + "&perPage=" + per_page;
    }
  }

  if (sorting && sorting.id) {
    if (sorting.id === "priority_id") {
      const isDesc = sorting.desc ? "true" : "false";
      endPoint = endPoint + "&sort=" + `${sorting.id},desc:${isDesc}`;
    } else {
      const direction = sorting.desc ? "desc" : "asc";
      endPoint = endPoint + "&sort=" + `${sorting.id},${direction}`;
    }
  }

  const fullUrl = basePathApiGolang + endPoint;
  if (!shouldDedupGolangPost(url)) {
    return apiClient.post(fullUrl, data, requestOptions);
  }

  const requestKey = `POST:${fullUrl}:body=${stableStringify(
    data
  )}:sorting=${stableStringify(sorting)}`;
  return withDedupedPostRequest(requestKey, () =>
    apiClient.post(fullUrl, data, requestOptions)
  );
}

function getCall_golang(url, sortOrder, pool) {
  const id = localStorage.getItem("orgId");
  const role = localStorage.getItem("currentRole");

  const requestOptions = {
    method: "GET",
    headers: golangHeader(),
    withCredentials: true,
  };

  if (pool !== undefined) {
    requestOptions.params = { poolTickets: pool };
  }

  const queryParams = new URLSearchParams({
    role: role || "",
    organization_id: id || "",
  });
  if (sortOrder !== undefined && sortOrder !== null && sortOrder !== "") {
    queryParams.append("commentSort", sortOrder);
  }
  const fullUrl = `${basePathApiGolang}${url}?${queryParams.toString()}`;
  const requestKey = `GET:${fullUrl}:params=${stableStringify(
    requestOptions.params
  )}`;
  return withDedupedGetRequest(requestKey, () =>
    apiClient.get(fullUrl, requestOptions)
  );
}

function getCallWithIdwithOrgId(url, id, orgId) {
  let role = localStorage.getItem("currentRole");
  const requestOptions = {
    method: "GET",
    // headers: authHeader(),
    withCredentials: true,
  };

  return apiClient
    .get(
      baseUrl +
      url +
      "/" +
      id +
      "?version=" +
      process.env.REACT_APP_VERSION +
      "&role=" +
      role +
      "&organization_id=" +
      orgId,
      requestOptions,
    )

}

function getFileUrl(url, data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  return apiClient
    .post(url, data, requestOptions)
}

